/**
 * ISO-3166 country list with a "preferred" group shown at top of the select.
 * Labels are English; we attach locale-aware display via Intl.DisplayNames when
 * the user's locale supports it, so the dropdown reads naturally in IT/EN/ES/PT/FR
 * without duplicating the list five times.
 */
export const ISO_COUNTRIES = [
    "AF","AL","DZ","AD","AO","AG","AR","AM","AU","AT","AZ",
    "BS","BH","BD","BB","BY","BE","BZ","BJ","BT","BO","BA","BW","BR","BN","BG","BF","BI",
    "KH","CM","CA","CV","CF","TD","CL","CN","CO","KM","CG","CD","CR","HR","CU","CY","CZ",
    "DK","DJ","DM","DO",
    "EC","EG","SV","GQ","ER","EE","SZ","ET",
    "FJ","FI","FR",
    "GA","GM","GE","DE","GH","GR","GD","GT","GN","GW","GY",
    "HT","HN","HU",
    "IS","IN","ID","IR","IQ","IE","IL","IT",
    "JM","JP","JO",
    "KZ","KE","KI","KP","KR","KW","KG",
    "LA","LV","LB","LS","LR","LY","LI","LT","LU",
    "MG","MW","MY","MV","ML","MT","MH","MR","MU","MX","FM","MD","MC","MN","ME","MA","MZ","MM",
    "NA","NR","NP","NL","NZ","NI","NE","NG","MK","NO",
    "OM",
    "PK","PW","PA","PG","PY","PE","PH","PL","PT",
    "QA",
    "RO","RU","RW",
    "KN","LC","VC","WS","SM","ST","SA","SN","RS","SC","SL","SG","SK","SI","SB","SO","ZA","SS","ES","LK","SD","SR","SE","CH","SY",
    "TW","TJ","TZ","TH","TL","TG","TO","TT","TN","TR","TM","TV",
    "UG","UA","AE","GB","US","UY","UZ",
    "VU","VA","VE","VN",
    "YE",
    "ZM","ZW",
];

export const PREFERRED_COUNTRIES = ["IT", "ES", "PT", "FR", "DE", "GB", "US", "BR", "AR", "MX"];

/**
 * Build a labeled list. Tries Intl.DisplayNames for locale-aware names and
 * falls back to ISO code when unavailable.
 */
export function buildCountryOptions(locale = "en") {
    let display = null;
    try {
        display = new Intl.DisplayNames([locale], { type: "region" });
    } catch (_e) {
        display = null;
    }
    const nameOf = (code) => (display ? display.of(code) || code : code);
    const preferred = PREFERRED_COUNTRIES.map((c) => ({ code: c, name: nameOf(c), group: "preferred" }));
    const rest = ISO_COUNTRIES
        .filter((c) => !PREFERRED_COUNTRIES.includes(c))
        .map((c) => ({ code: c, name: nameOf(c), group: "all" }))
        .sort((a, b) => a.name.localeCompare(b.name, locale));
    return { preferred, rest };
}
